import { ReactComponent as African } from '../../assets/icons/african.svg'
import { ReactComponent as Carrot } from '../../assets/icons/carrot.svg'
import { ReactComponent as Chilli } from '../../assets/icons/chilli.svg'
import { ReactComponent as Ethnic } from '../../assets/icons/ethnic.svg'
import { ReactComponent as New } from '../../assets/icons/happy.svg'
import { ReactComponent as Popular } from '../../assets/icons/popular.svg'
import { ReactComponent as Github } from '../../assets/icons/github.svg'
import { ReactComponent as Instagram } from '../../assets/icons/instagram.svg'
import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg'
import { ReactComponent as Twitter } from '../../assets/icons/twitter.svg'
import { ReactComponent as MenuBar } from '../../assets/icons/menu.svg'
import { ReactComponent as Close } from '../../assets/icons/close.svg'
import { ReactComponent as External } from '../../assets/icons/external.svg'

export const icons = {
	african: African,
	carrot: Carrot,
	chilli: Chilli,
	ethnic: Ethnic,
	new: New,
	popular: Popular,
	github: Github,
	instagram: Instagram,
	facebook: Facebook,
	twitter: Twitter,
	menu: MenuBar,
	close: Close,
	external: External,
}
